<template>
  <Dialog
    v-model:visible="isVisible"
    header="Privacy Consent"
    @hide="hide()"
    @show="show()"
    :dismissable="false"
    :draggable="false"
    :modal="true"
    :closable="false"
    :style="{ width: '30vw' }"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>
    <span class="p-text-secondary block mb-3"
      >To continue, please read our Privacy Policy and provide your
      consent</span
    >

    <a :href="urlPrivacyPolicy" target="_blank" class="mb-3"
      >View Privacy Policy</a
    >
    <div class="flex align-items-center gap-3 mb-3 mt-3">
      <YNCheckbox v-model="modelConfirm" :binary="true" />
      <label for="Hi11" class="ml-2"
        >I have read and accept the Privacy Policy</label
      >
    </div>
    <template #footer>
      <div v-if="processing" style="float: right !important">
        <ProgressSpinner style="width: 50px; height: 50px" />
      </div>
      <div v-else>
        <Button
          type="button"
          icon="pi pi-save"
          class="p-button p-button-success"
          :disabled="modelConfirm == 'N'"
          @click="checkConfirm()"
          label="Confirm"
        />
      </div>
    </template>
  </Dialog>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
  data() {
    return {
      v$: useVuelidate(),
      errMessage: null,
      url: this.$API_URL + "auth/confirm_privacypolicy",
      modelPassword: null,
      modelConfirm: "N",
      urlPrivacyPolicy: "",
      disableButton: false,
      processing: false,
      resetPassword: {
        currentPass: null,
        pass: null,
        confirmPass: null,
      },
    };
  },
  validations() {
    return {
      resetPassword: {
        pass: { required, minLength: minLength(8) },
        confirmPass: {
          required,
          sameAs: sameAs(this.resetPassword.pass),
        },
        currentPass: {
          required: requiredIf(this.requireCurrentPassword),
          minLength: minLength(8),
        },
      },
    };
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
    userdata: {
      type: Object,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    requireCurrentPassword: {
      type: Boolean,
      default: false,
    },
    initialErrorMessage: {
      type: String,
      default: "",
    },
    changeFirstLogin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      if (this.initialErrorMessage) {
        this.errMessage = this.initialErrorMessage;
      }
    },
    hide(changeSuccess, message) {
      this.resetPassword = {
        pass: null,
        confirmPass: null,
      };
      this.v$.$reset();
      this.errMessage = null;
      this.$emit("update:isVisible", false);
      this.$emit("hide", {
        success: changeSuccess,
        message: message,
      });
    },
    checkConfirm() {
      this.$emit("block-ui");
      this.processing = true;
      var self = this;

      this.$axios
        .post(this.url, {
          username: this.userId,
          privacypolicy: this.modelConfirm,
        })
        .then((response) => {
          if (response.data.success) {
            self.$emit("update:model", response.data.success);
            self.hide(true, response.data.message);
          } else {
            this.errMessage = "Failed: " + response.data.message;
            this.processing = false;
          }
          self.$emit("unblock-ui");
          self.disableButton = false;
        })
        .catch((err) => {
          self.disableButton = false;
          self.$emit("unblock-ui");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
        });
    },
    fetchUrl() {
      this.$axios
        .get(this.$UTIL_URL + "privacypolicy_url")
        .then((response) => {
          if (response && response.data.success) {
            this.urlPrivacyPolicy = response.data.data;
          }
        })
        .catch((error) => {
          //self.showError('Error Getting Order Type Data', error);
        });
    },
  },
  mounted() {
    // Mengambil URL dari backend saat komponen dimount
    this.fetchUrl();
  },
  emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
